import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { LazySection } from '../components/LazySection';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const MaterialPreview = lazy(() => import('../components/MaterialPreview').then(m => ({
  default: m.MaterialPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-271">
      <div data-id="element-272">
        {/* Hero — eager, above the fold */}
        <HeroSection data-id="element-273" />

        {/* Every section below mounts only when it's about to enter the viewport */}
        <LazySection minHeight={120} data-id="element-274">
          <TrustBar data-id="element-275" />
        </LazySection>

        <LazySection minHeight={500} data-id="element-276">
          <ContrastSection data-id="element-277" />
        </LazySection>

        <LazySection minHeight={500} data-id="element-278">
          <ForWhomSection data-id="element-279" />
        </LazySection>

        <LazySection minHeight={400} data-id="element-280">
          <BenefitsSection data-id="element-281" />
        </LazySection>

        <LazySection minHeight={600} data-id="element-282">
          <ContentPreview data-id="element-283" />
        </LazySection>

        <LazySection minHeight={600} data-id="element-284">
          <MaterialPreview data-id="element-285" />
        </LazySection>

        <LazySection minHeight={500} data-id="element-286">
          <BonusSection data-id="element-287" />
        </LazySection>

        <LazySection minHeight={600} data-id="element-288">
          <PricingSection data-id="element-289" />
        </LazySection>

        <LazySection minHeight={300} data-id="element-290">
          <GuaranteeSection data-id="element-291" />
        </LazySection>

        <LazySection minHeight={500} data-id="element-292">
          <TestimonialsSection data-id="element-293" />
        </LazySection>

        <LazySection minHeight={500} data-id="element-294">
          <FAQSection data-id="element-295" />
        </LazySection>

        <LazySection minHeight={200} data-id="element-296">
          <Footer data-id="element-297" />
        </LazySection>

        {/* Popup waits for idle behaviour internally; still keep it lazy */}
        <Suspense fallback={null} data-id="element-298">
          <SocialProofPopup data-id="element-299" />
        </Suspense>
      </div>
    </main>;
}